import React from 'react';
import moment from 'moment';

import StudentTabEditForm from './studentTabEditForm';
import Popup from '../../Popup';
import config from '../../../../config';
import { supportedPlayerStudentFileTypes, PlayerProfileTabIdentifiers } from '../../../utils/constants';

class StudentTabEditWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            showConfirmationPopup: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleRemoveExistingTranscript = this.handleRemoveExistingTranscript.bind(this);
        this.handleRemoveExistingTennisResume = this.handleRemoveExistingTennisResume.bind(this);
        this.uploadTranscript = this.uploadTranscript.bind(this);
        this.uploadTennisResume = this.uploadTennisResume.bind(this);
    }

    handleConfirmation() {
        this.setState({ showConfirmationPopup: false });
        window.location.href = `/profiles/${this.props.profile.playerId}?t=${PlayerProfileTabIdentifiers.STUDENT_INFO}`;
    }

    async handleSubmit(values) {
        console.log('values', values.values);
        const {
            collegeRecruiting,
            highSchoolId,
            highSchoolName,
            highSchoolLocation,
            highSchoolGpa,
            coursework,
            majorOfInterest,
            sat,
            act,
            toefl,
            coachFirstName,
            coachLastName,
            coachEmail,
            relationship,
            coachPhone,
            graduationMonth,
            graduationYear,
            updateTranscript,
            updateTennisResume,
        } = values.values;
        const graduationDate = moment.utc().startOf('month');
        graduationDate.set({
            ...(graduationMonth ? { month: graduationMonth - 1 } : {}),
            ...(graduationYear ? { year: graduationYear } : {}),
        });
        const valuesToPost = {
            collegeRecruiting,
            // schoolStartDate,
            highSchoolName,
            highSchoolLocation,
            graduationDate: graduationDate.format(),
            highSchoolId,
            highSchoolGpa,
            coursework,
            majorOfInterest,
            scores: {
                sat,
                act,
                toefl,
            },
            coach: {
                firstName: coachFirstName,
                lastName: coachLastName,
                email: coachEmail,
                phone: coachPhone,
                relationship,
            },
            updateTranscript,
            updateTennisResume,
        };
        this.setState({ submitting: true });

        const formData = new FormData();

        Object.keys(valuesToPost).forEach((key) => {
            if (valuesToPost[key] !== null && typeof (valuesToPost[key]) === 'object') {
                const currentValue = valuesToPost[key];

                Object.keys(currentValue).forEach((nestedKey) => {
                    if (currentValue[nestedKey] !== null && currentValue[nestedKey] !== undefined) {
                        formData.append(`${key}.${nestedKey}`, currentValue[nestedKey]);
                    }
                });
            } else if (valuesToPost[key] !== null && valuesToPost[key] !== undefined) {
                formData.append(key, valuesToPost[key]);
            }
        });

        formData.append('transcript', this.state.transcriptFile);
        formData.append('tennisResume', this.state.tennisResumeFile);

        const profileSaved = await this.props.savePlayerStudentInfo(formData);
        this.setState({ submitting: false });
        if (profileSaved) {
            this.setState({ showConfirmationPopup: true });
        }
    }

    handleCancel() {
        this.props.showEditForm();
    }

    handleRemoveExistingTranscript() {
        this.setState({
            transcriptFile: null,
        });
    }

    handleRemoveExistingTennisResume() {
        this.setState({
            tennisResumeFile: null,
        });
    }

    uploadTranscript(e) {
        if (supportedPlayerStudentFileTypes.indexOf(e.target.files[0].name.split('.').pop().toLowerCase()) === -1) {
            e.target.value = null;
            e.target.files = null;
            this.props.showError('Transcript upload failed. Unsupported file type.');
        } else {
            this.setState({
                transcriptFile: e.target.files[0],
            });
        }
    }

    uploadTennisResume(e) {
        if (supportedPlayerStudentFileTypes.indexOf(e.target.files[0].name.split('.').pop().toLowerCase()) === -1) {
            e.target.value = null;
            e.target.files = null;
            this.props.showError('Tennis resume upload failed. Unsupported file type.');
        } else {
            this.setState({
                tennisResumeFile: e.target.files[0],
            });
        }
    }

    buildDefaultValues(profileData, studentInfo) {
        if (!studentInfo) {
            return {};
        }
        return {
            collegeRecruiting: profileData.collegeRecruiting,
            graduationDate: studentInfo.graduationDate,
            ...(studentInfo.graduationDate ? {
                graduationMonth: moment(studentInfo.graduationDate).month() + 1,
                graduationYear: moment(studentInfo.graduationDate).year(),
            } : {}),
            highSchoolId: studentInfo.highSchoolId,
            highSchoolName: studentInfo.highSchoolName,
            highSchoolLocation: studentInfo.highSchoolLocation,
            highSchoolGpa: studentInfo.highSchoolGpa,
            coursework: studentInfo.coursework,
            majorOfInterest: studentInfo.majorOfInterest,
            sat: studentInfo.scores?.sat,
            act: studentInfo.scores?.act,
            toefl: studentInfo.scores?.toefl,
            coachFirstName: studentInfo.coach?.firstName,
            coachLastName: studentInfo.coach?.lastName,
            relationship: studentInfo.coach?.relationship,
            coachEmail: studentInfo.coach?.email,
            coachPhone: studentInfo.coach?.phone,
            secondaryPhone: studentInfo.coach?.secondaryPhone,
            transcriptFileName: studentInfo.transcriptFileName,
            transcriptLink: studentInfo.transcriptFileName ? `${config.apiHost}/v1/player/${profileData.id}/studentinfo/transcript?useOriginalFileName=true` : '',
            updateTranscript: false,
            tennisResumeFileName: studentInfo.tennisResumeFileName,
            tennisResumeLink: studentInfo.tennisResumeFileName ? `${config.apiHost}/v1/player/${profileData.id}/studentinfo/tennisresume?useOriginalFileName=true` : '',
            updateTennisResume: false,
        };
    }

    render() {
        console.log('StudentTabEditWrapper props', this.props);
        const { profile } = this.props;
        const { data: profileData } = profile;
        const { studentInfo } = profileData || {};
        const { submitting, showConfirmationPopup } = this.state;

        const defaultValues = this.buildDefaultValues(profileData, studentInfo);

        return (
            <>
                <StudentTabEditForm
                    handleSubmit={this.handleSubmit}
                    handleCancel={this.handleCancel}
                    defaultValues={defaultValues}
                    submitting={submitting}
                    handleRemoveExistingTranscript={this.handleRemoveExistingTranscript}
                    handleRemoveExistingTennisResume={this.handleRemoveExistingTennisResume}
                    handleUploadTranscriptFile={this.uploadTranscript}
                    handleUploadTennisResumeFile={this.uploadTennisResume}
                    currentUploadedTranscriptFileName={this.state.transcriptFile?.name}
                    currentUploadedTennisResumeFileName={this.state.tennisResumeFile?.name}
                />
                {showConfirmationPopup && (
                    <Popup
                        className="popup-sm"
                        config={{
                            showCloseIcon: false,
                            noPadding: false,
                            topGradient: true,
                        }}
                    >
                        <div>
                            <p
                                className="text-highlight1 text-dark text-center mb16"
                                data-testid="modal.profile.student-info.saved-text"
                            >
                                Saved successfully
                            </p>
                            <div className="row">
                                <div className="col-md-12 mb8">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm text-uppercase btn-block"
                                        onClick={() => this.handleConfirmation()}
                                        data-testid="modal.profile.student-info.got-it-btn"
                                    >
                                        Got it
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}
            </>
        );
    }
}

export default StudentTabEditWrapper;
